<template>
  <ul class="filtro-list">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="filtro-item"
      :class="{ selected: item.selected }"
      data-toggle="tooltip"
      data-placement="top"
      :title="item.text"
      @click="select(item)"
    >
      <span>{{ item.text }}</span>
    </li>
    <li v-if="items.length === 0" class="filtro-item">
      <span>Nenhum item encontrado.</span>
    </li>
  </ul>
</template>

<script>
import { filter } from 'lodash'
export default {
  name: 'SelectBox',
  props: ['items', 'onSelect'],
  methods: {
    select(item) {
      item.selected = !item.selected
      if (this.onSelect) {
        this.onSelect(filter(this.items, i => i.selected).map(i => i.id))
      }
    }
  }
}
</script>
